import Default from '@app/constants';
import { FilterUsers } from '@app/typings/services/winnonie/rider';
import { getRowsPerPage } from '@app/utils/localStorage';
import { get, set } from 'lockr';

const filterUsers: string = 'winnonie/users.filters';

export const setFilterUsersWinnonie = (value: FilterUsers) => {
  set(filterUsers, value);
};
export const getFilterUsersWinnonie = (): FilterUsers => {
  return get(filterUsers) || { filters: Default.filter.winnonie.users, pages: Default.pages };
};
export const clearFilterUsersWinnonie = () => {
  return set(filterUsers, {
    filters: Default.filter.winnonie.users,
    pages: {
      offset: Default.pages.offset,
      limit: getFilterUsersWinnonie().pages.limit || Number(getRowsPerPage()),
    },
  });
};
